import { useState } from "react";

// Input Validators
// import validator from "validator";
import isAlphanumeric from "validator/lib/isAlphanumeric";
import validateColor from "validate-color";

export const useCardFunc = (
  data,
  addVal = { cardName: "cardName", cardValue: "cardValue" }
) => {
  // Default Card funcionality
  const [card, setCard] = useState(data);

  // Editing / Toggling cardName
  const [nameEdit, setNameEdit] = useState(false);

  // Hovering Function for Cards for Delete Button
  const [hovered, setHovered] = useState(false);

  // Editing / Toggling fontValue
  const [optionEdit, setOptionEdit] = useState(false);

  // Editing / Toggling colorValue
  const [colorEdit, setColorEdit] = useState(false);

  // Toggling cardname
  const toggleName = (e) => {
    if (e.keyCode === 13 && nameEdit === true) return setNameEdit(false);
    setNameEdit(true);
  };

  // Toggling Color Card
  const toggleColor = (e) => {
    if (e.keyCode === 13 && colorEdit === true) return setColorEdit(false);
    setColorEdit(true);
  };

  // Toggling cardOptions
  const toggleOption = (e) => {
    if (e.keyCode === 13 && optionEdit === true) return setOptionEdit(false);
    setOptionEdit(true);
  };

  // Adding Card Function
  const addCard = () => {
    setCard([
      ...card,
      {
        id: card[card.length - 1].id + 1,
        num: card[card.length - 1].num + 1,
        ...addVal,
      },
    ]);
  };

  const deleteCard = (id) => {
    if (nameEdit === true) setNameEdit(false);
    if (optionEdit === true) setOptionEdit(false);

    if (id > card.length) {
      card[id].name = card[id + 1].name;
      card[id].value = card[id + 1].value;
    }

    let val = card.filter((val) => val.id !== id);
    setCard([...val]);

    for (let i = id + 1; i <= card.length - 1; i++) {
      card[i].num = card[i].num - 1;
      card[i].id = card[i].id - 1;
    }
  };

  // Live NAME INPUT
  const handleNameChange = (e, id) => {
    let entValue = e.target.value;
    let myCardName = card[id].cardName;

    // console.log(isAlphanumeric(validator.blacklist(entValue, " ")));

    // Validate (With Space Included) then Set Value
    // if (isAlphanumeric(validator.blacklist(entValue, " "))) {
    //   myCardName = entValue;
    // } else myCardName = "NO SPECIAL CHARACTERS";

    // Validate then Set Value
    if (isAlphanumeric(entValue)) myCardName = entValue;
    else myCardName = "NO SPECIAL CHARACTERS";

    card[id].cardName = myCardName;
    setCard([...card]);
  };

  // Live Color WIth Validation INPUT
  const handleColorChange = (e, id) => {
    let entValue = e.target.value;
    let myColorValue = card[id].cardValue;

    // Validate then Set Value
    if (validateColor(entValue)) myColorValue = entValue;

    card[id].cardValue = myColorValue;
    setCard([...card]);
  };

  // Live Font OPTIONS INPUT
  const handleOptionChange = (e, id) => {
    let entValue = e.target.value;

    card[id].cardValue = entValue;
    setCard([...card]);
  };

  return {
    card,
    setCard,
    hovered,
    setHovered,
    addCard,
    deleteCard,
    nameEdit,
    setNameEdit,
    optionEdit,
    setOptionEdit,
    colorEdit,
    setColorEdit,
    toggleName,
    toggleOption,
    toggleColor,
    handleNameChange,
    handleOptionChange,
    handleColorChange,
  };
};
